import { useEffect } from 'react'

type UseEscapeKeyProps = Readonly<{
  onEscape: () => void
  enabled?: boolean
}>

export const useEscapeKey = ({ onEscape, enabled = true }: UseEscapeKeyProps) => {
  useEffect(() => {
    if (!enabled) return

    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onEscape()
      }
    }

    document.addEventListener('keydown', handleEscape)
    
    return () => {
      document.removeEventListener('keydown', handleEscape)
    }
  }, [onEscape, enabled])
}